import React from 'react';

import CampaignGroups from '../../../../Common/Partials/CampaignGroups';

type Props = {
  basePath: string,
  record: any,
  resource: string
};

const CampaignGroupsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <CampaignGroups basePath={props.basePath} resource={props.resource} record={props.record} dropdownReference="helpers/campaigns/rtbs" />
  </div>
);

export default CampaignGroupsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Rtb/Partials/CampaignGroupsTab.tsx